import { useMemo } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import useVisibleMenuItems from './useVisibleMenuItems';

const MAX_RESULTS = 12;

/**
 * Pages matching the search term, among those the sidebar shows to this user,
 * matched against the titles in the current language. A group-name match lists
 * the group's pages ("finans" -> every finance page). Groups themselves are not
 * results: their paths (/calisan, ...) are not pages.
 */
const useMenuSearch = (term) => {
  const visibleMenuItems = useVisibleMenuItems();
  const { tMenu, locale } = useTranslation();

  return useMemo(() => {
    const normalize = (value) => value.toLocaleLowerCase(locale);
    const query = normalize(term.trim());
    if (!query) return [];

    const results = [];
    visibleMenuItems.forEach((item) => {
      const groupTitle = tMenu(item.path, item.title);
      const opensPage = item.submenu.length === 0 || item.path === '/dashboard';
      const groupMatches = normalize(groupTitle).includes(query);
      if (opensPage && groupMatches) {
        results.push({ path: item.path, title: groupTitle, group: null, groupPath: item.path });
      }
      item.visibleSubmenu.forEach((sub) => {
        const title = tMenu(sub.path, sub.title);
        if (groupMatches || normalize(title).includes(query)) {
          results.push({ path: sub.path, title, group: groupTitle, groupPath: item.path });
        }
      });
    });
    return results.slice(0, MAX_RESULTS);
  }, [term, visibleMenuItems, tMenu, locale]);
};

export default useMenuSearch;
